import { createApi } from '@reduxjs/toolkit/query/react';
import { baseQueryWithAuth } from './customersApi';

export interface ShippingQuotePayload {
  items: { productId: string; quantity: number }[];
  deliveryType: 'envio' | 'retiro';
}

export interface CreateOrderPayload {
  items: { productId: string; size: string; quantity: number }[];
  deliveryType: 'envio' | 'retiro';
  shippingAddress?: string;
  shippingLocality?: string;
  shippingProvince?: string;
  shippingPostalCode?: string;
}

export interface OrderItem {
  id: string;
  productId: string;
  productName: string;
  size: string;
  quantity: number;
  unitPrice: number;
  subtotal: number;
}

export interface Order {
  id: string;
  deliveryType: 'envio' | 'retiro';
  shippingAddress: string | null;
  shippingLocality: string | null;
  shippingProvince: string | null;
  shippingPostalCode: string | null;
  subtotal: number;
  shippingCost: number;
  total: number;
  paymentStatus: 'pending' | 'paid' | 'rejected' | 'cancelled' | 'review';
  fulfillmentStatus: 'preparando' | 'enviado' | 'entregado';
  createdAt: number;
  items: OrderItem[];
}

export const ordersApi = createApi({
  reducerPath: 'ordersApi',
  baseQuery: baseQueryWithAuth,
  endpoints: (build) => ({
    getShippingQuote: build.mutation<{ shippingCost: number }, ShippingQuotePayload>({
      query: (body) => ({ url: '/api/v1/shipping/quote', method: 'POST', body }),
      transformResponse: (r: { data: { shippingCost: number } }) => r.data,
    }),
    createOrder: build.mutation<{ orderId: string; initPoint: string }, CreateOrderPayload>({
      query: (body) => ({ url: '/api/v1/orders', method: 'POST', body }),
      transformResponse: (r: { data: { orderId: string; initPoint: string } }) => r.data,
    }),
    getMyOrders: build.query<Order[], void>({
      query: () => '/api/v1/orders/mine',
      transformResponse: (r: { data: Order[] }) => r.data,
    }),
    getOrder: build.query<Order, string>({
      query: (id) => `/api/v1/orders/${id}`,
      transformResponse: (r: { data: Order }) => r.data,
    }),
  }),
});

export const {
  useGetShippingQuoteMutation,
  useCreateOrderMutation,
  useGetMyOrdersQuery,
  useGetOrderQuery,
} = ordersApi;
